import { useMutation } from "@tanstack/react-query";
import { fetchClient } from "../generated/client";

export interface ReplayCreationActionsResultItem {
  id: string;
  email: "sent" | "skipped" | "error";
  webhooks: "sent" | "skipped" | "error";
  klaviyo: "sent" | "skipped" | "error";
  error?: string;
}

export interface ReplayCreationActionsResponse {
  results: ReplayCreationActionsResultItem[];
  summary: {
    emailsSent: number;
    webhooksSent: number;
    klaviyoSent: number;
    errors: number;
    total: number;
  };
}

// TODO: replace with $api.useMutation after running pnpm codegen post-deployment
export function useReplayCreationActions() {
  return useMutation({
    mutationFn: async (
      ids: string[],
    ): Promise<ReplayCreationActionsResponse> => {
      const { data, error } = await (
        fetchClient as unknown as {
          POST: (
            url: string,
            init: { body: { ids: string[] } },
          ) => Promise<{
            data?: ReplayCreationActionsResponse;
            error?: unknown;
          }>;
        }
      ).POST("/super-admin/return-requests/replay-creation-actions", {
        body: { ids },
      });
      if (error) throw error;
      return data!;
    },
  });
}
